<template>
  <div class="theme">
    <div class="page-header">
      <h1>{{ $t('settings.theme') }}</h1>
    </div>
    <Card shadow>
      <RadioGroup v-model="currentTheme">
        <Radio label="light">
          <span>{{ $t('settings.light') }}</span>
        </Radio>
        <Radio label="dark">
          <span>{{ $t('settings.dark') }}</span>
        </Radio>
      </RadioGroup>
      <div class="oper-col">
        <Button type="primary" @click="submitLang">{{ $t('common.submit') }}</Button>
      </div>
    </Card>
  </div>
</template>

<script>
export default {
  name: 'Theme',

  data() {
    return {
      currentTheme: 'dark',
    }
  },

  computed: {
    theme() {
      return this.$store.state.theme
    },
  },

  created() {
    this.currentTheme = this.theme
  },

  methods: {
    submitLang() {
      if (this.currentTheme === this.theme) {
        return
      }
      this.$store.dispatch('SET_THEME', this.currentTheme)
    },
  },
}
</script>

<style lang="scss">
.theme {
  .oper-col {
    margin-top: 40px;
    margin-bottom: 10px;
  }
  .ivu-radio-group {
    font-size: 18px;
  }
  .ivu-radio-wrapper {
    margin-right: 40px;
  }
}
</style>
